<template>
    <div id="box">
		<div style="text-align:center">
			<el-button type="primary" @click="toBorrowing">借用物品</el-button><br />
			<el-button type="primary" @click="toAccess">拿取物品</el-button><br />
			<el-button type="primary" @click="toBack">归还物品</el-button><br />
		</div>
		<div style="text-align: center;">
			<div class="clearfix">
			  <span>友情提示</span>
			</div>
			<div v-for="msg in msgs" :key="msg" class="text item">
			  {{msg}}
			</div>
		</div>
    </div>
</template>

<script>
export default {
  name: "ResourceBorrowingTotal",
  data(){
	  return {
		  msgs: [
			  "会一: 企业微信投屏",
			  "会四: 企业微信投屏",
			  "会三: 需要VFA接口",
			  "会六: 需要高清接口",
			  "培训: 需要高清接口"
		  ]
	  }
  },
  methods:{
    toAccess(){
      this.$router.push("/ResourceAccess?templateId=BsAaj2jBsqQs4JGV9xNh7oC9wj4GNj2t96EbYP8Sq")
      // this.$router.push("/ResourceAccess?templateId=BsAdia1DDHBiMCybzh678FzsnYkSdxG82PQCiaBwx")
    },
    toBack(){
      this.$router.push("/ResourceBack?templateId=3TmmLyWSme5Pw7xWboNBTMeRVb8XEMN6Hp6T1Pom")
    },
    toBorrowing(){
      this.$router.push("/ResourceBorrowing?templateId=BsAaj2jBsepHZNs7ACNVdZiVsv4yjT9mSJiYwriB2")
    }
  }
}
</script>

<style scoped>
#box{
  margin-left:17%;
  margin-right:17%;
  margin-top:17%
}
.el-button{
  width: 250px;
  height: 70px;
  margin-bottom: 40px;
  float: none;
}
</style>